import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/ev-savings-calculator',
  component: () => import('../../routes/EvSavingsCalculator.svelte'),
  card: {
    id: 'ev-savings-calculator',
    title: 'EV vs Gas Savings',
    description: 'Compare the total cost of ownership between electric vehicles and gas cars — including fuel, maintenance, insurance, and depreciation.',
    icon: 'electric_car',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/ev-savings-calculator',
    category: 'Travel & Distance',
  },
  seo: {
    title: 'EV vs Gas Car Savings Calculator – Total Cost of Ownership Comparison',
    description: 'Free EV savings calculator to compare electric vehicle vs gas car total cost of ownership. Includes fuel costs, maintenance, insurance, depreciation, and 7-year cost breakdown.',
  },
};

export default meta;